import React from "react";
import styled, { css, keyframes } from "styled-components/macro";

const rotate = keyframes`
  from {
    transform: translateX(-50%) scale(2) rotate(0deg);
  }
  to {
    transform: translateX(-50%) scale(2) rotate(360deg);
  }
`;
const rotateSmall = keyframes`
  from {
    transform: translateX(-50%) translateY(-30%) scale(1) rotate(0deg);
  }
  to {
    transform: translateX(-50%) translateY(-30%) scale(1) rotate(360deg);
  }
`;

const Svg = styled.svg<{ $type: "full" | "small" }>`
  height: 100vh;
  position: absolute;
  left: 50%;
  z-index: 0;
  overflow-x: hidden;

  ${({ $type }) =>
    $type === "small" &&
    css`
      top: 50%;
      width: auto;
      animation: ${rotateSmall} 120s linear infinite;
    `}

  ${({ $type }) =>
    $type === "full" &&
    css`
      top: 20%;
      animation: ${rotate} 120s linear infinite;
    `}
`;

type Props = {
  type?: "full" | "small";
};

const BlackFridayBackground: React.FC<Props> = ({ type = "full" }) => {
  return (
    <Svg $type={type} width="1500" height="1500" viewBox="0 0 964 964" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_253_2469)">
        <rect width="964" height="964" fill="#201B17" />
        <g opacity="0.15">
          <path
            d="M1765 586.758L1765 376.24L434.352 481.499L1765 586.758ZM-802 586.759L-802 376.241L528.649 481.499L-802 586.759Z"
            fill="#5F5F5F"
          />
          <path
            d="M1694.23 915.211L1748.47 712.654L435.955 469.287L1694.23 915.211ZM-785.467 250.344L-731.227 47.7881L527.046 493.711L-785.467 250.344Z"
            fill="#5F5F5F"
          />
          <path
            d="M1541.19 1213.9L1645.96 1032.45L441.22 457.928L1541.19 1213.9ZM-681.861 -69.4493L-577.087 -250.905L522.883 505.071L-681.861 -69.4493Z"
            fill="#5F5F5F"
          />
          <path
            d="M1314.85 1463L1463 1314.76L448.167 447.596L1314.85 1463ZM-500 -352.868L-351.849 -501.102L514.834 514.301L-500 -352.868Z"
            fill="#5F5F5F"
          />
          <path
            d="M1032.45 1645.96L1213.91 1541.15L457.929 440.647L1032.45 1645.96ZM-250.905 -578.14L-69.4484 -682.964L505.071 522.347L-250.905 -578.14Z"
            fill="#5F5F5F"
          />
          <path
            d="M712.659 1748.47L915.212 1694.23L469.29 435.957L712.659 1748.47ZM47.7885 -731.228L250.342 -785.467L493.71 527.044L47.7885 -731.228Z"
            fill="#5F5F5F"
          />
          <path
            d="M376.241 1765L586.759 1765L481.505 434.35L376.241 1765ZM376.241 -802L586.759 -802L481.505 528.654L376.241 -802Z"
            fill="#5F5F5F"
          />
          <path
            d="M47.7886 1694.23L250.342 1748.47L493.71 435.957L47.7886 1694.23ZM712.659 -785.467L915.212 -731.228L469.29 527.045L712.659 -785.467Z"
            fill="#5F5F5F"
          />
          <path
            d="M-250.905 1541.15L-69.4483 1645.96L505.071 440.647L-250.905 1541.15ZM1032.45 -682.964L1213.91 -578.141L457.929 522.347L1032.45 -682.964Z"
            fill="#5F5F5F"
          />
          <path
            d="M-500 1314.76L-351.849 1463L514.834 447.594L-500 1314.76ZM1314.85 -501.103L1463 -352.868L448.166 514.299L1314.85 -501.103Z"
            fill="#5F5F5F"
          />
          <path
            d="M-681.861 1032.45L-577.087 1213.9L522.883 457.928L-681.861 1032.45ZM1541.19 -250.906L1645.96 -69.4496L441.22 505.071L1541.19 -250.906Z"
            fill="#5F5F5F"
          />
          <path
            d="M-785.467 712.655L-731.227 915.211L527.045 469.287L-785.467 712.655ZM1694.23 47.7877L1748.47 250.344L435.955 493.711L1694.23 47.7877Z"
            fill="#5F5F5F"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_253_2469">
          <rect width="964" height="964" fill="white" />
        </clipPath>
      </defs>
    </Svg>
  );
};

export default BlackFridayBackground;
